import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../../Config";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getDueTypeLabel, getRole } from "../../../helpers";

const Table = ({
    apiData,
}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);


    const getPaymentStatus = (eventType, eventStatus) => {
        let label = 'Unknown';
        let color = 'text-gray-600 bg-gray-50';

        /* ---------------- Due ---------------- */
        if (eventType === 'DUE_CREATED') {
            label = 'Due Created';
            color = 'text-red-600 bg-red-50';
        }

        /* ---------------- Payment ---------------- */
        if (eventType === 'PAYMENT') {
            switch (eventStatus) {
                case 'PARTIAL':
                    label = 'Partial Payment';
                    color = 'text-amber-600 bg-amber-50';
                    break;

                case 'PENDING_CLEARED':
                    label = 'Pending Cleared';
                    color = 'text-emerald-600 bg-emerald-50';
                    break;

                case 'CLEARED':
                    label = 'Full Payment';
                    color = 'text-green-600 bg-green-50';
                    break;

                case 'SECURITY_ADJUSTMENT':
                    label = 'Adjustment from security';
                    color = 'text-green-600 bg-green-50';
                    break;

                case 'REFUND':
                    label = 'Refund';
                    color = 'text-green-600 bg-green-50';
                    break;

                case 'EXCESS':
                    label = 'Excess Payment';
                    color = 'text-blue-600 bg-blue-50';
                    break;
                default:
                    label = 'Due Created';
                    color = 'text-red-600 bg-red-50';
            }
        }

        /* ---------------- Refund ---------------- */
        if (eventType === 'REFUND') {
            label = 'Refund Issued';
            color = 'text-blue-600 bg-blue-50';
        }

        /* ---------------- Reversal ---------------- */
        if (eventType === 'REVERSAL') {
            label = 'Transaction Reversed';
            color = 'text-gray-600 bg-gray-50';
        }

        /* ---------------- Security Adjustment ---------------- */
        if (eventType === 'SECURITY_ADJUSTMENT') {
            label = 'Adjusted from Security';
            color = 'text-orange-600 bg-orange-50';
        }

        return (
            <span
                className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${color}`}
            >
                {label}
            </span>
        );
    };


    //   Negative entry means Payment
    //   Positive entry means dues
    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({


                //getProperty: getProperty(item),
                date: moment(
                    item.collectionDate ?? item.createdAt,
                ).format('DD MMM, YYYY'),
                activity: getPaymentStatus(item.eventType, item.eventStatus),
                amount: '₹' + 
                (item.eventStatus === 'REFUND' ? item.refundAmount : Math.abs(item.amount)),
                for: item.type === Config.dueType.OTHER ? item?.title : getDueTypeLabel(item.type),
                desc: item?.description || ''
                // dues: getDues(item),
                // roomNum: getPropertyName(item),
                // moveInOutDate: isMovingOut === 'M' ? <MoveOutData>{item.moveOutDate}</MoveOutData> : moveInOutDate(item),
                // status: combineStatusAndKyc(item),
                // action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const getDateAndTime = (item) => (
        <div className="flex flex-col leading-tight">
            <span className="text-gray-700 text-sm font-medium">
                {moment(item.createdAt).format("DD MMM YYYY")}
            </span>
            <span className="text-gray-400 text-xs">
                {moment(item.createdAt).format("hh:mm A")}
            </span>
        </div>
    );

    const getUserInfo = (item) => (
        <div className="flex flex-col leading-tight">
            <span className="text-gray-800 text-sm font-medium">
                {item?.doneByName || "--"}
            </span>
            <span className="text-gray-400 text-xs">
                {getRole(item?.doneByRole)}
            </span>
        </div>
    );

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Date & Time",
                    accessor: "date",
                },

                {
                    Header: "Done By",
                    accessor: "by",
                },
            ];
        }
        return [
            {
                Header: "Date",
                accessor: "date",
            },
            {
                Header: "For",
                accessor: "for",
            },
            {
                Header: "Activity",
                accessor: "activity",
            },
            {
                Header: "Amount",
                accessor: "amount",
            },
            // {
            //     Header: "Debit",
            //     accessor: "debit",
            //     width: 50
            // },
            // {
            //     Header: "Credit",
            //     accessor: "credit",
            //     width: 50
            // },
            // {
            //     Header: "Balance",
            //     accessor: "balance",
            //     Cell: ({ value }) => (
            //         <span className="font-medium text-gray-700">
            //             {value}
            //         </span>
            //     ),
            // },
            // {
            //     Header: "Direction",
            //     accessor: "direction",
            //     width: 50
            // },
            {
                Header: "Desc",
                accessor: "desc",
                Cell: ({ value }) => (
                    <div className="whitespace-normal text-gray-600">
                        {value}
                    </div>
                ),
            },
            //   {
            //     Header: "Platform",
            //     accessor: "platform",
            //     width: 50
            //   },
        ];
    }, [isMobileView]);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    // useEffect(() => {
    //   setPageSize(PaginationLimit);
    // }, []);

    useEffect(() => {
        setCurrentPage(pageIndex); // Update current page on state change
    }, [pageIndex]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td {...cell.getCellProps()} style={cell.column.width ? { width: cell.column.width } : {}}>
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">

                                                <li>
                                                    <strong>Activity:</strong> {data[rowIndex].description}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600 md:table-fixed`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`
  ${(props) => (props.hasdata === "true" ? "border-b" : "")}
  even:bg-gray-50
  hover:bg-slate-100
`;

const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
//const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Td = tw.td`
  p-3
  text-sm
  text-left
  align-top
  truncate
`;

export default Table;
